// extracted by mini-css-extract-plugin
export default {"search_form":"SearchForm_search_form__3fa+Z","search_input":"SearchForm_search_input__tYq+2","submit_btn":"SearchForm_submit_btn__Wwgon"};